import CardForm from './components/CardForm';

function App() {
  return (
    <div className="min-h-screen bg-black">
      <CardForm />
    </div>
  );
}

export default App;